import 'layui/dist/layui.js';
import $ from 'jquery';
import '../../js/api.mjs';

import 'layui/dist/css/layui.css';

const layui = window.layui;

layui.use(['form', 'layer', 'laypage'], function () {
	const form = layui.form;
	const layer = layui.layer;

	form.render();

	// 图形验证码id
	let codeId = null
	// tokin
	let tokin = null

	// 点击图片刷新验证码
	$('#imgyzm').on('click', function () {
		getImgCode()
	})

	// 获取图形验证码
	getImgCode()

	function getImgCode() {
		ajax(`${url}/learn/captcha`).then(res => {
			codeId = res.result.id
			$('#imgbase').attr('src', `data:image/jpg;base64,${res.result.img}`)
		})

	}

	// 切换登录方式
	$('#acclogin').on('click', function () {
		$(this).attr('class', 'denglu-fs-list denglu-fs-list-active')
		$('#tellogin').attr('class', 'denglu-fs-list denglu-fs-list-default')
		$('.denglu-con-acc').css('display', 'block')
		$('.denglu-con-tel').css('display', 'none')
	})
	$('#tellogin').on('click', function () {
		$(this).attr('class', 'denglu-fs-list denglu-fs-list-active')
		$('#acclogin').attr('class', 'denglu-fs-list denglu-fs-list-default')
		$('.denglu-con-acc').css('display', 'none')
		$('.denglu-con-tel').css('display', 'block')
	})

	// 手机发送验证码
	$('body').on('click', '#getyzm', function () {
		var phone = $('#telacc').val().trim()
		var phoneres = /^[1][3,4,5,6.7,8,9][0-9]{9}$/
		var imgcodes = $('#telimgcode').val()
		if (!phoneres.test(phone)) {
			layer.msg('请输入正确的手机号码', {
				icon: 7,
			})
			return false
		}
		if (imgcodes == '') {
			layer.msg('请输入图形验证码', {
				icon: 7,
			})
			return false
		}

		ajax(`${url}/learn/sendsmscode`, 'post', JSON.stringify({
			mobile: phone,
			codeId: codeId,
			code: imgcodes
		})).then(res => {
			layer.msg('发送成功', {
				icon: 1,
				time: 1000,
			})
		})


	})


	// 重置密码
	$('.rpsw').on('click', function () {
		// 弹窗
		layer.open({
			type: 2,
			title: '重置密码',
			area: ['600px', '450px'], // 100%全屏
			cancel: function (index) {
				//右上角关闭
				layer.close(index);
			},
			content: ['/viws/member/layer/rpsw.html',
				'no'
			] //这里content是一个URL，如果你不想让iframe出现滚动条，你还可以content: ['http://sentsin.com', 'no']
		});
	})




	$(document).keydown(function (event) {
		if (event.keyCode == 13) {
			if ($('.denglu-con-acc').css('display') == 'block') {
				zhdl()
			} else {
				sjdl()
			}
		}
	})

	// 手机登录
	function sjdl() {
		var phone = $('#telacc').val().trim()
		var phonecode = $('#telcode').val().trim()

		if (phone == '') {
			layer.msg('请输入手机号码', {
				icon: 7
			})
			return false
		}
		if (phonecode == '') {
			layer.msg('请输入短信验证码', {
				icon: 7
			})
			return false
		}

		ajax(`${url}/learn/mobilelogin`, 'post', JSON.stringify({
			phone: phone,
			code: phonecode,
		})).then(res => {
			loginSuccess(res)
		})
	}


	// 手机登录
	$('#teldenglus').on('click', function () {
		sjdl()
	})

	// 账号密码登录
	function zhdl() {
		var accid = $('#acc').val().trim()
		var accpsw = $('#psw').val().trim()

		if (accid == '' || accpsw == '') {
			layer.msg('请输入账号或密码', {
				icon: 7
			})
			return false
		}

		ajax(`${url}/learn/login`, 'post', JSON.stringify({
			userName: accid,
			password: accpsw,
		})).then(res => {
			loginSuccess(res)
		})
	}

	// 账号密码登录
	$('#denglus').on('click', function () {
		zhdl()
	})

	// 登录成功后执行事件
	function loginSuccess(res) {
		// if (res.code == 200) {
		tokin = res.result.token
		// 保存tokin
		window.localStorage.setItem('tokin', tokin);
		// 保存用户id
		window.localStorage.setItem('memberId', res.result.memberId);

		// 获取用户信息
		ajax(`${url}/member/getMemberInfo`).then(result => {

			// 保存用户信息(包含用户名、参赛组别等)
			window.localStorage.setItem('userInfo', JSON.stringify(result.result));
			// 保存用户名  
			window.localStorage.setItem('username', result.result
				.username);
			// 保存参赛组别  低年级-高年级  1,2,3,4
			window.localStorage.setItem('matchLevel', result.result
				.matchLevel);
			// 用户项目
			result.result.memberServices.forEach(e => {
				getyhxm(e.memberService)
			})

			layer.msg('登录成功', {
				icon: 1,
			},
				function () {
					if (window.localStorage.getItem('pageurl')) {
						location.replace(window.localStorage.getItem('pageurl'))
					} else {

						location.replace('/index.html')
					}

				},
			)
		})



	}

	// 获取用户项目保存本地，其他页面直接调用
	function getyhxm(serviceId) {
		ajax(`${url}/learnMember/Statistics/${serviceId}`, 'post', JSON.stringify({
			serviceId: serviceId
		})).then(res => {

			// services id>详情
			window.localStorage.setItem(res.result.serviceId, JSON.stringify(res.result));
		})
	}
});
